import React from "react";
import SaveTestToken from "./components-lib/saveTestToken";
import WebFaSolutionTestComponent from "./components/webFaSolutionTestComponent";
import EndpointTestingRoutes from "./endpointTestingRoutes";

export default function App() {
  return (
    <div>
      {/* <SaveTestToken /> */}
      <WebFaSolutionTestComponent />
      <EndpointTestingRoutes />
    </div>
  );
}
